import React from 'react';
import { useDispatch } from 'react-redux';
import { onSortItemSelected } from '../../Actions/ProductFiltering.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const ProductSorting = () => {
  const dispatch = useDispatch();
  const { sortCriteria } =
    useTypedSelector((state) => state.productFiltering) ?? {};

  const selectedSortItem = sortCriteria?.sortItems.find((s) => s.selected);

  return sortCriteria ? (
    <select
      value={selectedSortItem?.query}
      onChange={(e) =>
        dispatch(
          onSortItemSelected(
            sortCriteria?.sortItems.find((s) => s.query == e.target.value)
          )
        )
      }
    >
      {sortCriteria.sortItems.map((item) => (
        <option value={item.query} key={item.query}>
          {item.name}
        </option>
      ))}
    </select>
  ) : null;
};

export default ProductSorting;
